import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { rootPaths } from 'routes/paths';
import { authPaths } from 'features/auth/routes/paths';
import { ForgotPasswordPage } from 'features/auth/pages/ForgotPasswordPage';
import { ResetPasswordPage } from 'features/auth/pages/ResetPasswordPage';
import { SignUpPage } from 'features/auth/pages/SignUpPage';
import { LoginPage } from 'features/auth/pages/LoginPage';
import { GeneratePasswordPage } from 'features/auth/pages/GeneratePasswordPage';
import { AutoLoginPage } from 'features/auth/pages/AutoLoginPage';
import { SuccessfulSignUp } from 'features/auth/components/SuccessfulSignUpMessage';

export const AuthRoutes = () => {
  return (
    <Switch>
      <Route exact path={authPaths.static.login} component={LoginPage} />
      <Route exact path={authPaths.static.autologin} component={AutoLoginPage} />
      <Route exact path={authPaths.static.signUp} component={SignUpPage} />
      <Route exact path={authPaths.static.successfulSignUp} component={SuccessfulSignUp} />
      <Route exact path={authPaths.static.forgotPassword} component={ForgotPasswordPage} />
      <Route exact path={authPaths.static.resetPassword} component={ResetPasswordPage} />
      <Route exact path={authPaths.static.generatePassword} component={GeneratePasswordPage} />

      <Route exact path={rootPaths.static.root}>
        <Redirect to={authPaths.static.login} />
      </Route>

      <Route>
        <Redirect to={rootPaths.static.notFound} />
      </Route>
    </Switch>
  );
};
